import { render } from "./SurgeryView.vue?vue&type=template&id=bb901e5a&scoped=true"
import script from "./SurgeryView.vue?vue&type=script&lang=js"
export * from "./SurgeryView.vue?vue&type=script&lang=js"

import "./SurgeryView.vue?vue&type=style&index=0&id=bb901e5a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb901e5a"]])

export default __exports__